import React from 'react';
import { Helmet } from 'react-helmet-async';

const AboutUs = () => {
  return (
    <div className="container mt-5">
      <Helmet>
        <title>About Us - Vakralabs</title>
        <meta name="description" content="Learn more about our team and mission to simplify complexity through software." />
        <meta property="og:title" content="About Us - Vakralabs Services" />
        <meta property="og:description" content="Learn about our expertise in custom software, APIs, and mobile/web development." />
      </Helmet>

      <h1 className="text-center mb-4">About Us</h1>
      <div className="row">
        <div className="col-md-8 mx-auto">
          <p className="lead">
            Vakralabs Services is a technology-driven company dedicated to simplifying complexity and delivering creativity.
            We specialize in building innovative digital products, custom software, and scalable solutions for businesses of all sizes.
          </p>
          <p>
            Our mission is to empower organizations and communities with user-friendly digital tools, seamless integrations, and reliable support.
            With a focus on quality, transparency, and customer satisfaction, we help clients achieve digital transformation and sustainable growth.
          </p>
          <div className="my-4">
            <strong>What We Offer:</strong>
            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-2 g-3 mt-2">
              <div className="col">
                <div className="card border-0 shadow-sm h-100 text-center bg-light">
                  <div className="card-body py-3">
                    <span role="img" aria-label="software" style={{ fontSize: "1.5em" }}>💻</span>
                    <div className="fw-bold mt-2">Custom Software Development</div>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card border-0 shadow-sm h-100 text-center bg-light">
                  <div className="card-body py-3">
                    <span role="img" aria-label="mobile" style={{ fontSize: "1.5em" }}>📱</span>
                    <div className="fw-bold mt-2">Mobile & Web Application Development</div>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card border-0 shadow-sm h-100 text-center bg-light">
                  <div className="card-body py-3">
                    <span role="img" aria-label="api" style={{ fontSize: "1.5em" }}>🔌</span>
                    <div className="fw-bold mt-2">API Integration & Consulting</div>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card border-0 shadow-sm h-100 text-center bg-light">
                  <div className="card-body py-3">
                    <span role="img" aria-label="analytics" style={{ fontSize: "1.5em" }}>📊</span>
                    <div className="fw-bold mt-2">Data Analytics & Reporting</div>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card border-0 shadow-sm h-100 text-center bg-light">
                  <div className="card-body py-3">
                    <span role="img" aria-label="support" style={{ fontSize: "1.5em" }}>🛠️</span>
                    <div className="fw-bold mt-2">Technical Support & Maintenance</div>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card border-0 shadow-sm h-100 text-center bg-light">
                  <div className="card-body py-3">
                    <span role="img" aria-label="document" style={{ fontSize: "1.5em" }}>📄</span>
                    <div className="fw-bold mt-2">Digital Document Management</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>
            Vakralabs Services is based in Pune, Maharashtra, and serves clients across India and beyond.
            Our experienced team is passionate about technology, committed to excellence, and ready to help you achieve your goals.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs; 